import { ButtonSizes } from "@roc-digital/ui-web";
import { Button, ButtonVariants } from "../Button";
import { Heading2 } from "../Typefaces";
import { Modal } from "../Modal";
import React from "react";
import { Input } from "../Input";

export function prompt(content: any, title: string, value?: string) {
  return new Promise<string>((res: any, rej) => {
    Modal.open('mxm.modal', <Prompt
      title={title}
      content={content}
      value={value || ''}
      onYes={res}
      onNo={() => res(null)}
    />, 'medium');
  });
}

interface PromptProps {
  title: string;
  content: any;
  value: string;
  onYes: (value: string | null) => void;
  onNo?: () => void;
}

function Prompt(props: PromptProps) {

  const [value, setValue] = React.useState(props.value)

  const closeModal = () => {
    Modal.close('mxm.modal');
  };

  return <div className="p-8">
    <Heading2 className={'mb-8 text-admin-dark !font-extrabold !text-[26px]'}>{props.title}</Heading2>
    <div>
      <br />
      {props.content}
      <br />
      <Input changeEvent={e => {
        const name = e.target.value || '';
        setValue(name);
      }} value={value}/>
      <br />
    </div>

    <div>
      <div className="mt-4 flex inline-block gap-2">
        <Button clickEvent={() => {
          if(props.onNo) props.onNo();
          closeModal();
        }} size={ButtonSizes.medium} variant={ButtonVariants.secondary}>Cancel</Button>
        <span className="flex-grow"></span>
        <Button clickEvent={() => {
          closeModal();
          props.onYes(value);
        }} size={ButtonSizes.medium}>Confirm</Button>
      </div>
    </div>
  </div>
}